/*
 * Copyright 2026 Sergey S. Chernov real.sergeych@gmail.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

package net.sergeych.lyng.matrix

import net.sergeych.lyng.obj.ObjReal

internal fun formatMatrixValue(value: Double): String {
    if (value.isFinite()) {
        val asLong = value.toLong()
        if (asLong.toDouble() == value) {
            return asLong.toString()
        }
    }
    return ObjReal.of(value).toString()
}
